/**
 * @desc 报损审核明细
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.storageReportDamage.damageDetailList.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/storageReportDamage/damageDetailList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
